import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    RabItemsWrapper,
    RabItemsWrapperSelection,
    RabItemsWrapperMarket,
} from 'src/domains/sportsbook/betting/bettingTab/cashout/selection/selectionNew/legsInBet/RabSelections.style';

interface RabSelectionsPropsType {
    selections: {
        market: { name: string };
        selection: { name: string };
    }[];
}

export const RabSelections = observer('RabSelections', ({ selections }: RabSelectionsPropsType) => {
    return (
        <>
            {selections.map((item) => {
                return (
                    <RabItemsWrapper
                        key={item.selection.name}
                        data-test='rab-item'
                    >
                        <RabItemsWrapperSelection data-test='selection-name'>
                            {item.selection.name}
                        </RabItemsWrapperSelection>

                        <RabItemsWrapperMarket data-test='market-name'>{item.market.name}</RabItemsWrapperMarket>
                    </RabItemsWrapper>
                );
            })}
        </>
    );
});
